import { Platform, UserActionTimestamps } from "../common";

export enum PolicyType {
    default = "default",
    production = "production",
    test = "test",
    development = "development",
}

export enum ConnectorCategoryDlp {
    onPrem = "onPrem",
    cloud = "cloud",
    social = "social",
    unmanaged = "unmanaged",
    highRisk = "highRisk",
    communication = "communication",
}

export enum IdentityProvider {
    azureActiveDirectory = "azureActiveDirectory",
    azureActiveDirectoryB2c = "azureActiveDirectoryB2c",
    facebook = "facebook",
    linkedin = "linkedin",
    google = "google",
    twitter = "twitter",
    microsoft = "microsoft",
}

export enum EndpointAccessType {
    allow = "allow",
    deny = "deny",
}

export interface ConnectorDetailsApiModel {
    id: string;
    displayName: string;
}

export interface EndpointModel {
    url: string;
    access?: EndpointAccessType;
}

export interface PolicyConfig {
    allowConnectionsToProdEnvs: boolean;
    allowConnectionsToNonProdEnvs: boolean;
    allowedDomains: string[];
    allowedNumOfBuilders: number;
    numOfHighPrivilegedUsersInEnvironment: number;
    numOfCriticalPrivilegedUsersInEnvironment: number;
    allowedNumOfPrivilegedIdentitiesInWorkspace: number;
    allowedNumOfPrivilegedIdentitiesToDashboard: number;
    allowedNumOfPrivilegedIdentitiesToDataset: number;
    allowedNumOfPrivilegedIdentitiesToReport: number;
    allowedNumOfPrivilegedIdentitiesToAgent: number;
    allowedNumOfPrivilegedIdentitiesToAiSkill: number;
    allowedNumOfPrivilegedIdentitiesToGpt: number;
    connectorList: { string: string[] };
    allowedIdentityProviders: IdentityProvider[];
    endpoints: EndpointModel[];
}

export interface PolicyMinimalModel {
    id: string;
    integrationId: string;
    platform: Platform;
    name: string;
}

export interface PolicyModel {
    id: string;
    zenityAccountId: string;
    integrationId: string;
    platform: Platform;
    name: string;
    description: string;
    isDefault: boolean;
    type: PolicyType;
    userActionTimeStamps: UserActionTimestamps;
    config: PolicyConfig;
    generalConnectorList: ConnectorDetailsApiModel[];
}

export interface PolicyToUpdateModel {
    name?: string;
    description?: string;
    type?: PolicyType;
    config?: PolicyConfig;
}

export interface PolicyToAdd {
    name: string;
    type: PolicyType;
    fromPolicyId?: string;
    description?: string;
    config?: PolicyConfig;
}
